import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedLayout = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    // Build redirect path with encoded current URL (path + search)
    const redirectPath = `${location.pathname}${location.search}`;

    return <Navigate to={`/login?redirect=${encodeURIComponent(redirectPath)}`} replace />;
  }

  return <Outlet />;
};

export default ProtectedLayout;
